import { useEffect, useState } from "react";
import { auth, provider } from "../../firebase/config";
import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Container, Button, Modal, Form } from "react-bootstrap";
import { doc, setDoc, serverTimestamp, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";


export default function Login() {
  const navigate = useNavigate();

  const headlines = [
    "Introverts replying Extroverts",
    "Married Men's Group replying Single Men's Group...",
    // "Engaged Women's Group replying Engaged Men's Group...",
    // "LGBTQ+ replying Straight Group...",
    "Divorcee's Group replying  Married Group...",
    "Gen Z replying Millennials...",
    // "Remote Workers replying Office Workers...",
    "Cat Owners replying Dog Owners...",
    // "Coffee Lovers replying Tea Lovers...",
    "Marvel Fans replying DC Fans...",
    "Vegans replying Meat Eaters...",
    // "Parents replying Non-Parents...",
    // "City Dwellers replying Suburbanites...",
    // "Book Lovers replying Movie Buffs...",
    "Muslim Group replying Christian Group...",
    "Apple Users replying Android Users...",
    // "Optimists replying Pessimists...",
    // "Artists replying Scientists...",
  ];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % headlines.length);
        setFade(true);
      }, 400);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const signIn = async () => {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        // const genUsername = generateUsername(user.displayName);

      // New user, create document
      await setDoc(userRef, {
        username: user.displayName,
        photoURL: user.photoURL,
        email: user.email,
        createdAt: serverTimestamp(),
        changedUsername: false,
        stats: {
          totalVotesReceived: 0,
          officialMessages: 0,
          groupsJoined: 0,
          groupsStarted: 0
        }
      });

      // setGeneratedUsername(genUsername);
      // setUsername(genUsername);
      // setShowUsernameModal(true);
    }else{
      // update only things safe to refresh
      await updateDoc(userRef, {
        email: user.email
      });
    }

    navigate("/dashboard");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto",
        padding: "20px"
      }}
    >
      <Container style={{ maxWidth: "950px", textAlign: "center" }}>

        {/* Logo */}
        <div style={{ marginBottom: "10px", marginTop: "30px" }}>
          <h2 style={{ color: "#0a4601", fontStyle: "italic", fontWeight: 700 }}>
            GroupYarn
          </h2>
        </div>

        {/* Headline */}
        <div
          style={{
            minHeight: "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
            padding: "0 10px"
          }}
        >
          <h1
            style={{
              fontSize: "clamp(26px, 5vw, 48px)", // responsive font
              fontWeight: 900,
              lineHeight: 1.25,
              color: "#072a01",
              opacity: fade ? 1 : 0,
              transition: "opacity 0.4s ease",
              maxWidth: "800px"
            }}
          >
            {headlines[index].split("replying")[0]}
            <em>replying</em>
            {headlines[index].split("replying")[1]}
          </h1>
        </div>

        {/* Features */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 260px))",
            gap: "35px",
            marginBottom: "45px",
            // alignItems: "start",
            justifyContent: "center"
          }}
        >
          <Feature
            title="Suggest Group's Replies"
            text="Suggest replies to chats from the other group."
          />

          <Feature
            title="Influence Group's Replies"
            text="Vote for suggested replies that best represent your group's view."
          />

          <Feature
            title="Reply As A Group"
            text="The most voted replies becomes your group's official response."
          />
        </div>

        {/* Button */}
        <Button
          onClick={signIn}
          style={{
            background: "linear-gradient(135deg, #2d512f, #318333)",
            border: "none",
            padding: "14px 30px",
            fontSize: "18px",
            borderRadius: "10px",
            fontWeight: 600
          }}
          className="rounded-pill"
        >
          Sign in with Google
        </Button>

        <p
          style={{
            marginTop: "25px",
            color: "#888",
            fontSize: "14px"
          }}
        >
          Keep conversation open.
        </p>

      </Container>

    </div>
  );
}

function Feature({ title, text }) {
  return (
    <div
      style={{
        maxWidth: "260px",
        margin: "0 auto"
      }}
    >
      <h4
        style={{
          fontSize: "18px",
          fontWeight: 600,
          marginBottom: "8px",
          color: "#111"
        }}
      >
        {title}
      </h4>
      <p
        style={{
          fontSize: "15px",
          color: "#666",
          lineHeight: 1.5
        }}
      >
        {text}
      </p>
    </div>
  );
}